import { Button, InputAdornment, TextField, Typography, Box } from "@material-ui/core";
import React, { FC, useState } from "react";
import { useStyles } from "./styles";
import SearchIcon from "@mui/icons-material/Search";
import AddIcon from "@mui/icons-material/Add";
import { AddCompany } from "../../add-company";
import SeverityButtonGroup from "./../button-group";
import { useSelector } from "react-redux";
import constants from "./../../../../utils/constants";
import { ControlledSwitch } from "../../../common/controlled-switch";

interface BookClosureHeaderProps {
  defaultSearchText?: string;
  onSearch: (searchText: string) => void;
  handleSeverityLevelChange: (level: string) => void;
  handleApplyTeamCodeSwitchToggle: (status: boolean) => void;
}
export const BookClosureHeader: FC<BookClosureHeaderProps> = ({
  defaultSearchText = "",
  onSearch,
  handleApplyTeamCodeSwitchToggle,
  handleSeverityLevelChange,
}) => {
  const user = useSelector((state: any) => state.user);
  const classes = useStyles();
  const [isOpen, setIsOpen] = useState(false);
  const [searchText, setSearchText] = useState<string>(defaultSearchText);
  const [showTeamCodeFilter, setToggleTeamCodeFilter] = useState<boolean>(false);

  const handleChange = ({ target: { value } }: React.ChangeEvent<HTMLInputElement>) => {
    setSearchText(value);
    onSearch(value);
  };

  const handleOpenCompany = () => {
    setIsOpen(true);
  };

  const handleCloseCompany = () => {
    setIsOpen(false);
  };

  const handleToggleTeamCodeFilter = (value: boolean) => {
    setToggleTeamCodeFilter(value);
    handleApplyTeamCodeSwitchToggle(value);
  };

  return (
    <>
      <Box>
        <Typography className={classes.typography}>{constants.BOOK_CLOSURE_DASHBOARD.HEADER_TEXT}</Typography>
      </Box>
      <Box className={classes.mainContainer}>
        <Box className={classes.searchBar}>
          <TextField
            value={searchText}
            variant="outlined"
            data-testid="search-input"
            size="small"
            onChange={handleChange}
            fullWidth
            placeholder="Search by Company Legal Name, CIF, CRM ID, Team Code, or Codat ID"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon className={classes.searchIcon} />
                </InputAdornment>
              ),
              classes: {
                input: classes.searchTypography,
              },
            }}
          />
        </Box>
        <Box className={classes.teamFilterWrapper}>
          <ControlledSwitch
            label={"Apply Team Code Filter"}
            defaultStatus={showTeamCodeFilter}
            handleSwitchToggle={handleToggleTeamCodeFilter}
            dataTestId="apply-team-code-toggle"
          />
        </Box>
        <Box className={classes.itemEnd}>
          {user?.user_role === "admin" ? (
            <Button
              variant="outlined"
              size="medium"
              color="primary"
              startIcon={<AddIcon />}
              onClick={handleOpenCompany}
              data-testid="addCompany"
            >
              ADD COMPANY
            </Button>
          ) : null}
          <AddCompany open={isOpen} onClose={handleCloseCompany} />
        </Box>
      </Box>
      <Box className={`${classes.mainContainer} ${classes.marginBotton}`}>
        <Box>
          <SeverityButtonGroup handleSeverityLevelChange={handleSeverityLevelChange} />
        </Box>
      </Box>
    </>
  );
};
